import Box from '@mui/material/Box';
import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';

export type ProfileShareNewLinkDialogProps = {
  open: boolean;
  profileTitle: string;
  onCancel: () => void;
  onSubmit: () => void;
  shareNewLinkError: boolean;
};

const ProfileShareNewLinkDialog = ({
  open,
  profileTitle,
  onCancel,
  onSubmit,
  shareNewLinkError,
}: ProfileShareNewLinkDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      onSubmit={onSubmit}
      onClose={() => onCancel()}
      open={open}
      content={
        <>
          {!shareNewLinkError && (
            <Box>
              <TextV2 component="span">
                <Trans
                  i18nKey="ui.event-management.learner.profiles.share-new-link.confirmation"
                  components={{
                    bold: <TextV2 component="span" variant="bodyBold" />,
                  }}
                  values={{ title: profileTitle }}
                />
              </TextV2>
            </Box>
          )}
          {shareNewLinkError && (
            <Box>
              {t('ui.event-management.learner.profiles.error.share-new-link')}
            </Box>
          )}
        </>
      }
      primaryButtonText={
        shareNewLinkError
          ? ''
          : t(
              'ui.event-management.learner.profiles.share-new-link.submit.button',
            )
      }
      secondaryButtonText={
        shareNewLinkError
          ? t('ui.event-management.email-profiles.ok.button')
          : t(
              'ui.event-management.learner.profiles.share-new-link.cancel.button',
            )
      }
      title={t('ui.event-management.learner.profiles.share-new-link.title')}
    />
  );
};

export default ProfileShareNewLinkDialog;
